import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Address } from '@k2/common/entities-state/types';
import { HhgAddress, HhgDestinationAddress, HhgOriginAddress, HhgOriginStorageAddress } from '@k2/staff/content/clients/client/assignment/hhg/overview/addresses/list/addresses-list.component';

@Component({
    selector: 'address-block',
    templateUrl: 'address-block.component.html',
    styleUrls: ['address-block.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AddressBlockComponent {
  @Input() address: Address | HhgAddress | HhgOriginAddress | HhgOriginStorageAddress | HhgDestinationAddress;
  @Input() reducedFormat?: boolean = false;
  @Input() isAssignmentEncrypted: boolean = false;
}
